import interfaceImage01 from '../images/signPagesCarousel/interface01.png';
import interfaceImage02 from '../images/signPagesCarousel/interface02.png';
import interfaceImage03 from '../images/signPagesCarousel/interface03.png';
import interfaceImage04 from '../images/signPagesCarousel/interface04.png';
import interfaceImage05 from '../images/signPagesCarousel/interface05.png';
import interfaceImage06 from '../images/signPagesCarousel/interface06.png';

export const introCarousel = [
    {
        img: interfaceImage01,
        title: 'Access Centralized CLO Issuance',
        text: [
            "Compare specific tranches or entire CLO deals with ease",
            "Use pre-set views: Deal, Class, or K-Matrix for fast insights",
            "Filter across 25+ parameters to analyze new issue, refi, and resets",
            "Visualize structural shifts and pricing trends with intuitive charts",
            "Get email alerts on deal changes throughout the syndication"
        ]
    },
    {
        img: interfaceImage02,
        title: 'Analyze BWIC Pipeline',
        text: [
            "Filter by currency, price, or duration to find relevant CLOs",
            "See BWIC PX Talk across multiple dealers",
            "Quickly access and understand BWIC rules",
            "Review historical trade data for context",
            "Set up email alerts for specific managers or criteria"
        ]
    },
    {
        img: interfaceImage03,
        title: 'Seamlessly Execute Online',
        text: [
            "List CLOs for sale in seconds",
            "Trade anonymously or with attribution using 5 rule templates",
            "Receive and auto-rank electronic bids",
            "Get instant feedback on pricing and execution",
            "Accept bids and trade with a single click"
        ]
    },
    {
        img: interfaceImage04,
        title: 'Unlock CLO Pricing with EVAL™',
        text: [
            "Full-universe CLO pricing across the stack",
            "Access via front end, FTP, or API",
            "Intraday pricing updates",
            "Multi-model approach captures CLO complexity",
            "Responsive support and transparent challenge process"
        ]
    },
    {
        img: interfaceImage05,
        title: 'Get Key Metrics on a Dashboard ',
        text: [
            "Visualize the BWIC pipeline",
            "Find the perfect time for your next BWIC",
            "Compare TRACE and BWIC volumes",
            "Review detailed results from prior trading sessions",
            "Analyze key market health indicators"
        ]
    },
    {
        img: interfaceImage06,
        title: 'Stay Updated with K-Watch News',
        text: [
            "Stay updated on primary and secondary CLO markets",
            "Discover new platform features",
            "Access KopenTech research and insights",
            "Read third-party CLO analysis",
            "Receive daily email updates"
        ]
    }
];